import { Component, inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { LanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";
import { STORE_LINKS } from '../../constants/store-links';

@Component({
  selector: 'app-henter-pant',
  templateUrl: './henter-pant.component.html',
  styleUrl: './henter-pant.component.scss'
})
export class HenterPantComponent implements OnInit, OnDestroy {
  private _translateService: TranslateService = inject(TranslateService);
  private _router: Router = inject(Router);
  private _languageService: LanguageService = inject(LanguageService);
  private _platformId = inject(PLATFORM_ID);

  screens: {src: string, alt: string, icon: string, player?: boolean, team?: boolean; tip: string;}[] = [];
  langSubscription!: Subscription;
  private _carouselIntervalId: ReturnType<typeof setInterval> | null = null;
  currentIndex = 0;
  currentLanguage!: string;
  readonly storeLinks = STORE_LINKS;

  constructor() {
  }

  ngOnInit(): void {
    this.currentLanguage = this._languageService.currentLang;

    this.setScreens();
    if (isPlatformBrowser(this._platformId)) {
      this.initCarousel();
    }
    setTimeout(() => {
      this.languageSubscription();
    }, 0)
  }

  initCarousel(): void {
    this._carouselIntervalId = setInterval(() => {
      if (this.screens.length > 0) {
        this.currentIndex = (this.currentIndex + 1) % this.screens.length;
      }
    }, 4000);
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe((event: any) => {
      this.currentLanguage = event.lang;
      this.setScreens();
    });
  }

  setScreens(): void {

    this._translateService.get([
      'HOME.HENTERPANT.TIPS.PLAYER_STATS',
      'HOME.HENTERPANT.TIPS.TEAM_PICKUP_STATUS',
      'HOME.HENTERPANT.TIPS.PLAYER_PICKUP_STATUS',
      'HOME.HENTERPANT.TIPS.TEAM_MANAGEMENT',
      'HOME.HENTERPANT.TIPS.PLAYER_SHARE_PROFILE',
      'HOME.HENTERPANT.TIPS.TEAM_REPORTS',
      'HOME.HENTERPANT.TIPS.TEAM_SHARE_PROFILE'
    ]).subscribe(translations => {
      const currentLang: string = this._translateService.currentLang;
      console.log('currentLang', currentLang);
      this.screens = [
        {
          src: `assets/images/carousel/${currentLang}/personal-statistics.png`,
          alt: 'personal statistics',
          icon: 'custom-chart-bar',
          player: true,
          tip: translations['HOME.HENTERPANT.TIPS.PLAYER_STATS']
        },
        {
          src: `assets/images/carousel/${currentLang}/pickup-control.png`,
          alt: 'pickup control',
          icon: 'custom-eye-show',
          team: true,
          tip: translations['HOME.HENTERPANT.TIPS.TEAM_PICKUP_STATUS']
        },
        {
          src: `assets/images/carousel/${currentLang}/pickup-process.png`,
          alt: 'pickup process',
          icon: 'custom-status-change',
          player: true,
          tip: translations['HOME.HENTERPANT.TIPS.PLAYER_PICKUP_STATUS']
        },
        {
          src: `assets/images/carousel/${currentLang}/team-management.png`,
          alt: 'team management',
          icon: 'custom-git-pull-request',
          team: true,
          tip: translations['HOME.HENTERPANT.TIPS.TEAM_MANAGEMENT']
        },
        {
          src: `assets/images/carousel/${currentLang}/profile-sharing-player.png`,
          alt: 'profile sharing player',
          icon: 'custom-bullhorn',
          player: true,
          tip: translations['HOME.HENTERPANT.TIPS.PLAYER_SHARE_PROFILE']
        },
        {
          src: `assets/images/carousel/${currentLang}/team-reports.png`,
          alt: 'team reports',
          icon: 'custom-report-analytics',
          team: true,
          tip: translations['HOME.HENTERPANT.TIPS.TEAM_REPORTS']
        },
        {
          src: `assets/images/carousel/${currentLang}/profile-sharing-team.png`,
          alt: 'profile sharing team',
          icon: 'custom-bullhorn',
          team: true,
          tip: translations['HOME.HENTERPANT.TIPS.TEAM_SHARE_PROFILE']
        }
      ];
    });

  }

  goToSignUp(): void {
    const currentLang: string = this._translateService.currentLang;
    const queryParams = {tab: 'sign-up'};
    this._router.navigate([`/${currentLang}/henter-pant/profile`], {queryParams});
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
    if (this._carouselIntervalId != null) {
      clearInterval(this._carouselIntervalId);
      this._carouselIntervalId = null;
    }
  }
}
